import LoginButton from "../buttons/login.button";
import { useNavigate } from "react-router-dom";
import useLogin from "../../hooks/users/useLogin";
import LoginInputGroup from "../inputGroups/login.input.group";

const LoginForm = () => {
  const { loginForm, setLoginForm, handleLogin } = useLogin();
  const { email, password } = loginForm;
  const navigate = useNavigate();

  const handleChange = (e) => {
    setLoginForm({ ...loginForm, [e.target.name]: e.target.value });
  };

  const handleReset = () => {
    navigate("/reset-password");
  };

  return (
    <form className="w-[50%] max-w-lg border-animate rounded-2xl shadow-lg  flex flex-col justify-center items-center gap-4 p-8 bg-gray-200">
      <div className="flex flex-col w-full">
        <LoginInputGroup field="email" value={email} onChange={handleChange} />
        <LoginInputGroup
          field="password"
          value={password}
          onChange={handleChange}
        />
      </div>

      <LoginButton onLogin={(e) => handleLogin(e)} />
      <div
        className="font-ubuntuLightItalic hover:underline hover:cursor-pointer text-[#1877f2]"
        onClick={handleReset}
      >
        Forgot Password?
      </div>
    </form>
  );
};

export default LoginForm;
